export default function CTABanner() {
  return (
    <section className="relative w-full min-h-[380px] md:min-h-[420px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20panoramic%20fashion%20lifestyle%20scene%20with%20neutral%20cream%20textures%2C%20soft%20natural%20lighting%2C%20minimalist%20product%20displays%20with%20folded%20clothing%2C%20warm%20earthy%20tones%2C%20clean%20modern%20aesthetic%2C%20editorial%20photography%2C%20organic%20composition%2C%20elegant%20atmosphere&width=1600&height=700&seq=cta-banner-01&orientation=landscape"
          alt="OOPBuy Spreadsheet"
          className="w-full h-full object-cover object-center"
        />
      </div>
      <div className="absolute inset-0 bg-black/55"></div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-start md:items-end justify-between gap-8">
          <div className="max-w-lg">
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-white leading-tight mb-4 lowercase">
              bereit für den besten oopbuy spreadsheet?
            </h2>
          </div>
          <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="inline-flex items-center gap-3 px-6 py-3 bg-white text-foreground-950 text-sm font-semibold rounded-full hover:bg-white/90 transition-colors cursor-pointer whitespace-nowrap"
            >
              Zum Shop
              <div className="w-6 h-6 rounded-full bg-foreground-950 flex items-center justify-center">
                <i className="ri-arrow-right-line text-white text-xs"></i>
              </div>
            </a>
            <p className="text-white/60 text-xs md:text-sm">
              Entdecke tausende <br /> geprüfte Produkte
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}